const escapeHtml = (value) => String(value ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;');

export const MEMBERSHIP_FORM_VARIABLES = ['firstName', 'lastName', 'userTypeName', 'clubName'];

export const DEFAULT_MEMBERSHIP_HTML_FORM = `
<div style="max-width:800px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;color:#334155;background:#ffffff;">

  <!-- Header -->
  <div style="text-align:center;padding:24px;">
    <img src="/logo512.png" alt="Club Logo" width="110" style="border-radius:20px;margin-bottom:16px;">
    <h1 style="margin:0;color:#0f172a;">Application for Membership</h1>
    <p style="margin-top:12px;color:#64748b;font-size:16px;">
      Please complete the application below. All membership applications are considered by the {{clubName}} Committee.
    </p>
  </div>

  <!-- Membership Application -->
  <div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:24px;margin-bottom:24px;">
    <h2 style="margin-top:0;color:#0f172a;">Membership Application</h2>

    <p style="line-height:1.7;margin-bottom:18px;">
      I, <span style="font-weight:600;color:#0f172a;">{{firstName}} {{lastName}}</span>, hereby apply to be admitted as a member of {{clubName}} under the category of <span style="font-weight:600;color:#0f172a;">{{userTypeName}}</span>.
    </p>
    <p>If my application is successful, I agree to abide by the Constitution, rules, codes of conduct, and by-laws of {{clubName}}, as well as those of the eThekwini Tennis Association (eTA) and Tennis South Africa (TSA).</p>
    <p style="margin-bottom:0;">
      I acknowledge that failure to comply with the Constitution, rules, codes of conduct, or by-laws of the Club may result in disciplinary action, including the suspension or termination of my membership, at the discretion of the {{clubName}} Committee.
    </p>
  </div>

  <!-- Personal Details -->
  <div style="border:1px solid #e2e8f0;border-radius:10px;padding:24px;margin-bottom:24px;">
    <h2 style="margin-top:0;color:#0f172a;">Personal Details</h2>

    <div style="display:flex;flex-wrap:wrap;gap:16px;">

      <label style="display:block;flex:1 1 calc(50% - 16px);">
        <span style="display:block;margin-bottom:6px;font-size:14px;font-weight:600;color:#334155;">Date of Birth</span>
        <input type="date" name="dateOfBirth" required style="width:100%;padding:12px;border:1px solid #cbd5e1;border-radius:6px;box-sizing:border-box;font-family:inherit;font-size:14px;color:#334155;background:#ffffff;">
      </label>

      <label style="display:block;flex:1 1 calc(50% - 16px);">
        <span style="display:block;margin-bottom:6px;font-size:14px;font-weight:600;color:#334155;">ID Number</span>
        <input type="text" name="idNumber" required placeholder="ID or passport number" style="width:100%;padding:12px;border:1px solid #cbd5e1;border-radius:6px;box-sizing:border-box;font-family:inherit;font-size:14px;color:#334155;">
      </label>

      <label style="display:block;flex:1 1 calc(50% - 16px);">
        <span style="display:block;margin-bottom:6px;font-size:14px;font-weight:600;color:#334155;">Residential Address</span>
        <input type="text" name="address" required placeholder="Street address, suburb, city" style="width:100%;padding:12px;border:1px solid #cbd5e1;border-radius:6px;box-sizing:border-box;font-family:inherit;font-size:14px;color:#334155;">
      </label>

      <label style="display:block;flex:1 1 calc(50% - 16px);">
        <span style="display:block;margin-bottom:6px;font-size:14px;font-weight:600;color:#334155;">Cell Number</span>
        <input type="tel" name="cellNumber" required placeholder="+27..." style="width:100%;padding:12px;border:1px solid #cbd5e1;border-radius:6px;box-sizing:border-box;font-family:inherit;font-size:14px;color:#334155;">
      </label>

      <label style="display:block;width:100%;">
        <span style="display:block;margin-bottom:6px;font-size:14px;font-weight:600;color:#334155;">
          Name of Previous Club <span style="font-weight:normal;color:#64748b;">(optional)</span>
        </span>
        <input type="text" name="previousClub" placeholder="Former club name" style="width:100%;padding:12px;border:1px solid #cbd5e1;border-radius:6px;box-sizing:border-box;font-family:inherit;font-size:14px;color:#334155;">
      </label>

    </div>
  </div>

  <!-- Emergency Information -->
  <div style="border:1px solid #e2e8f0;border-radius:10px;padding:24px;margin-bottom:24px;">
    <h2 style="margin-top:0;color:#0f172a;">Emergency Information</h2>

    <div style="display:flex;flex-wrap:wrap;gap:16px;">

      <label style="display:block;flex:1 1 calc(50% - 16px);">
        <span style="display:block;margin-bottom:6px;font-size:14px;font-weight:600;color:#334155;">Emergency Contact Name</span>
        <input type="text" name="emergencyContactName" required placeholder="John Smith" style="width:100%;padding:12px;border:1px solid #cbd5e1;border-radius:6px;box-sizing:border-box;font-family:inherit;font-size:14px;color:#334155;">
      </label>

      <label style="display:block;flex:1 1 calc(50% - 16px);">
        <span style="display:block;margin-bottom:6px;font-size:14px;font-weight:600;color:#334155;">Medical Aid Scheme <span style="font-weight:normal;color:#64748b;">(optional)</span></span>
        <input type="text" name="medicalAid" placeholder="Scheme name" style="width:100%;padding:12px;border:1px solid #cbd5e1;border-radius:6px;box-sizing:border-box;font-family:inherit;font-size:14px;color:#334155;">
      </label>

      <label style="display:block;flex:1 1 calc(50% - 16px);">
        <span style="display:block;margin-bottom:6px;font-size:14px;font-weight:600;color:#334155;">Emergency Contact Relationship</span>
        <input type="text" name="relationship" required placeholder="Spouse, Parent, Friend..." style="width:100%;padding:12px;border:1px solid #cbd5e1;border-radius:6px;box-sizing:border-box;font-family:inherit;font-size:14px;color:#334155;">
      </label>

      <label style="display:block;flex:1 1 calc(50% - 16px);">
        <span style="display:block;margin-bottom:6px;font-size:14px;font-weight:600;color:#334155;">Medical Aid Number <span style="font-weight:normal;color:#64748b;">(optional)</span></span>
        <input type="text" name="medicalAidNumber" placeholder="Membership number" style="width:100%;padding:12px;border:1px solid #cbd5e1;border-radius:6px;box-sizing:border-box;font-family:inherit;font-size:14px;color:#334155;">
      </label>

      <label style="display:block;flex:1 1 calc(50% - 16px);">
        <span style="display:block;margin-bottom:6px;font-size:14px;font-weight:600;color:#334155;">Emergency Contact Number</span>
        <input type="tel" name="emergencyContactPhone" required placeholder="+27..." style="width:100%;padding:12px;border:1px solid #cbd5e1;border-radius:6px;box-sizing:border-box;font-family:inherit;font-size:14px;color:#334155;">
      </label>

    </div>
  </div>

  <!-- Indemnity -->
  <div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:24px;margin-bottom:24px;">
    <h2 style="margin-top:0;color:#0f172a;">Assumption of Risk and Indemnity</h2>
    <p style="margin-bottom:0;">
      I acknowledge that participation in any activities and the use of the Club's facilities are undertaken at my own risk. I hereby indemnify and hold harmless {{clubName}}, its committee members, employees, and representatives from any liability for injury, loss, or damage of whatsoever nature that I may suffer while on the Club premises or participating in Club activities.
    </p>
  </div>

  <!-- Declaration -->
  <div style="background:#f0fdf4;border:1px solid #86efac;border-radius:10px;padding:24px;margin-top:24px;">
    <h2 style="margin-top:0;color:#166534;">Declaration and POPIA Consent</h2>
    <p>
      In terms of the Protection of Personal Information Act (POPIA), I hereby give voluntary, specific, and informed authorisation to {{clubName}} to collect, process, store, and use my personal information for lawful and legitimate Club-related purposes, including administration, communication, and registration with affiliated bodies such as eThekwini Tennis Association (eTA) and Tennis South Africa (TSA).
    </p>

    <p style="margin-bottom:8px;">By submitting this application, I confirm that:</p>
    <ul style="padding-left:20px;margin-top:0;">
      <li>The information I have provided is true and correct.</li>
      <li>I agree to abide by the Constitution, rules, codes of conduct and by-laws of {{clubName}}.</li>
      <li>I acknowledge the Assumption of Risk and Indemnity above.</li>
      <li>I consent to the processing of my personal information in accordance with POPIA.</li>
    </ul>

    <label style="display:block;margin-top:20px;font-weight:bold;font-size:15px;">
      <input type="checkbox" name="agreeTerms" required style="margin-right:8px;width:16px;height:16px;accent-color:#2563eb;vertical-align:middle;">
      I acknowledge and agree to the above declaration.
    </label>
  </div>

  <!-- Notes -->
  <div style="background:#fffbeb;border:1px solid #fde68a;border-radius:10px;padding:24px;margin-top:24px;">
    <h2 style="margin-top:0;color:#92400e;">Notes</h2>
    <ul style="padding-left:20px;margin-bottom:0;">
      <li>There is a waiting period of approximately two (2) weeks during which the {{clubName}} Committee will consider the application.</li>
      <li>During this period, applicants for membership are requested to attend Saturday afternoon sessions to allow the Committee to assess their standard of play.</li>
      <li>While membership is under consideration, applicants may use the courts (subject to availability) upon payment of the prescribed visitor's fee.</li>
    </ul>
  </div>

  <!-- Footer -->
  <div style="text-align:center;color:#94a3b8;font-size:13px;margin-top:32px;padding-bottom:24px;">
    Thank you for your application. We look forward to welcoming you to {{clubName}}. 
  </div>

</div>
`.trim();

export const getMembershipFormVariables = (user, { userTypeName, clubName } = {}) => ({
  firstName: String(user?.firstName ?? '').trim(),
  lastName: String(user?.lastName ?? '').trim(),
  userTypeName: String(userTypeName ?? user?.userType ?? '').trim(),
  clubName: String(clubName ?? '').trim(),
});

export const MEMBERSHIP_FORM_PREVIEW_VARIABLES = {
  firstName: 'Jane',
  lastName: 'Doe',
  userTypeName: 'Social Member',
  clubName: 'Sample Tennis Club',
};

export const getMembershipFormPreviewVariables = (user, { userTypeName, clubName } = {}) => {
  const fromUser = getMembershipFormVariables(user, { userTypeName, clubName });
  if (fromUser.firstName || fromUser.lastName) {
    return fromUser;
  }

  return {
    ...MEMBERSHIP_FORM_PREVIEW_VARIABLES,
    userTypeName: fromUser.userTypeName || MEMBERSHIP_FORM_PREVIEW_VARIABLES.userTypeName,
    clubName: fromUser.clubName || MEMBERSHIP_FORM_PREVIEW_VARIABLES.clubName,
  };
};

export const interpolateMembershipForm = (html, variables = {}) => {
  if (!html) return '';

  return html.replace(/\{\{(\w+)\}\}/g, (match, key) => {
    if (!MEMBERSHIP_FORM_VARIABLES.includes(key)) return match;

    const value = variables[key];
    if (value == null || String(value).trim() === '') return match;

    return escapeHtml(value);
  });
};
